export const GET_STOCKS = "GET_STOCKS";
export const GET_BANKS = "GET_BANKS";
export const GET_USER_INFO = "GET_USER_INFO";
export const PURCHASE = "PURCHASE";
export const GET_TXS = "GET_TXS";
export const GET_SETTINGS = "GET_SETTINGS";
export const SET_SETTINGS = "SET_SETTINGS";
export const GET_CURRENCIES = "GET_CURRENCIES";
export const PURCHASE_EXTERNAL = "PURCHASE_EXTERNAL";
export const PURCHASE_APPROVE = "PURCHASE_APPROVE";
export const GET_STORES = "GET_STORES";
export const GET_MARKET_INFO = "GET_MARKET_INFO";
export const PURCHASE_CHECK = "PURCHASE_CHECK";
export const ADD_COINBASE = "ADD_COINBASE";
export const GET_EXCHANGES = "GET_EXCHANGES";
export const ADD_BINANCE = "ADD_BINANCE";
export const ADD_KRAKEN = "ADD_KRAKEN";
export const DELETE_STOCK = "DELETE_STOCK";
export const GET_PAYMENT_OPTIONS = "GET_PAYMENT_OPTIONS";
export const ADD_BANK = "ADD_BANK";
export const CURRENCY_COMPARE = "CURRENCY_COMPARE";
export const AUTH_EXCHANGE = "AUTH_EXCHANGE";
export const CHECK_BALANCE = "CHECK_BALANCE";
export const VALIDATE_EXCHANGE_PAYMENT = "VALIDATE_EXCHANGE_PAYMENT";
export const EXCHANGE_PAYMENT = "EXCHANGE_PAYMENT";
export const GET_STOCK_EXCHANGES = "GET_STOCK_EXCHANGES";
export const GET_EXCHANGES_DEPOSIT_ADDRESS = "GET_EXCHANGES_DEPOSIT_ADDRESS";
export const LIMIT_UPDATE = "LIMIT_UPDATE";
export const DEFAULT_EXCHANGE = "DEFAULT_EXCHANGE";
export const SET_ACCOUNT = "SET_ACCOUNT";
export const SET_TAB = "SET_TAB";
export const GET_EXTERNAL_STATUS = "GET_EXTERNAL_STATUS";
export const WEBSOCKET_RESPONSES = "WEBSOCKET_RESPONSES";
export const ETH = "ETH";
export const USDT = "USDT";
export const ETHER = "ether";
export const T_ETHER = "tether";
export const META_MASK_COINS = [ETH];
export const GET_PAYABLE_AMOUNT = "GET_PAYABLE_AMOUNT";
export const GET_PREVIOUS_TRANSACTION_DATA = "GET_PREVIOUS_TRANSACTION_DATA";
export const PARTIAL_TX = "Partial";
export const EXTERNAL_STATUS_TIMER = 60;
export const IFRAME_STATUS = "IFRAME_STATUS";
export const IFRAME_STATUS_OPEN = "open";
export const IFRAME_STATUS_CLOSE = "close";
export const USER_TRACK_EVENTS = "USER_TRACK_EVENTS";
export const WALLET_PAYMENT_CONFIRMED = "WALLET_PAYMENT_CONFIRMED";
export const SET_HOSTED_PAGE_INFO = "SET_HOSTED_PAGE_INFO";
export const SET_RESULT_PAGE_DATA = "SET_RESULT_PAGE_DATA";
export const FORM_OPENED = "FORM_OPENED";
export const RAISE_PARTIAL_REFUND = "RAISE_PARTIAL_REFUND";
export const CHECK_KYT = "CHECK_KYT";
export const FEEDBACK_STATE = "FEEDBACK_STATE";
export const GET_EXTERNAL_STATUS_EVENT = "GET_EXTERNAL_STATUS_EVENT";
export const INITIAL_ROUTE = ["hostedPage", "select-currency"];
export const CHECK_REWARDS_OPTIN_STATUS = "CHECK_REWARDS_OPTIN_STATUS";
export const ENROLL_REWARDS_PROGRAM = "ENROLL_REWARDS_PROGRAM";
export const ESITMATE_REWARDS = "ESITMATE_REWARDS";
export const GET_REWARDS_BALANCE = "GET_REWARDS_BALANCE";
export const REWARD_SIGN_UP = "REWARD_SIGN_UP";
export const COMPLIANCE_BLOCKED_STATUS = 303;
export const GET_SUMSUB_CREATE = "GET_SUMSUB_CREATE";
export const GET_SUMSUB_OBTAIN = "GET_SUMSUB_OBTAIN";
export const GET_SUMSUB_STATUS = "GET_SUMSUB_STATUS";
export const GET_AMLBOT_CREATE = "GET_AMLBOT_CREATE";
export const GET_AMLBOT_OBTAIN = "GET_AMLBOT_OBTAIN";
export const GET_AMLBOT_STATUS = "GET_AMLBOT_STATUS";